module.exports = {

  init () {
    
    this.mapFilters();
    this.headings();
    this.cookie();

  },
  
  mapFilters() {

    $(".wpgmza-marker-listing-category-filter > label").click(function() {
      $( ".wpgmza-marker-listing-category-filter" ).toggleClass( "show" );
      var count = $(".wpgmza-marker-listing-category-filter [type='checkbox']:checked").length;
      if(count > 0){
        if($(".wpgmza-marker-listing-category-filter > label span").length > 0){
          $(".wpgmza-marker-listing-category-filter > label span").remove();
        }
        $(".wpgmza-marker-listing-category-filter > label").append( "<span>" + count + "</span>" );
        
      }
      if($(".wpgmza-marker-listing-category-filter").hasClass("show")){
        $(".wpgmza-marker-listing-category-filter").append( "<div class='clear-all'>Clear all</div>" );
      } else{
        $(".clear-all").remove();
      }
    });
    
    $(document).on('click', '.clear-all', function() {
      console.log('clear-all');
      $(".wpgmza-marker-listing-category-filter [type='checkbox']:checked").each(function(){
         $(this).click();
       });
       if($(".wpgmza-marker-listing-category-filter > label span").length > 0){
         $(".wpgmza-marker-listing-category-filter > label span").remove();
       }
    });
    
    $(".wpgmza_cat_checkbox_item_holder").click(function() {
      if(!$('img[src*=marker-main]').parent().parent().hasClass("map-markers")){
        $('img[src*=marker-main]').parent().parent().addClass("map-markers");
      }
      
      $.each([ 'holder_1', 'holder_8', 'holder_16', 'holder_23' ], function( index, value ) {
        if($(".wpgmza_cat_checkbox_item_"+ value +" [type='checkbox']:checked").length > 0){
          if(!$('.map-markers').hasClass("marker-"+ value)){
            $('.map-markers').addClass("marker-"+ value);
          } 
        } else{
          if($('.map-markers').hasClass("marker-"+ value)){
            $('.map-markers').removeClass("marker-"+ value);
          }  
        }
      });
      
    });
      
  },
  
  headings() {
    $(document).ready(function(){
      $( "h1" ).wrapInner( "<span></span");
      $( "h2" ).wrapInner( "<span></span");
    });  
  },
  
  cookie() {
    $(document).ready(function(){
      $.cookieBar({
      message: "This website uses cookies to ensure you get the best experience on our website. For more information visit our <a href='/privacy-policy'>Privacy Policy</a>.",
      acceptText: "I'm happy with that",
      fixed: true,
      policyButton: false,
      policyText: "Find out more",
      policyURL: "/privacy-policy"
    });
    });  
  
  },
  
  mainSlider() {
    const swiper = new Swiper('.main-slider-container', {
      // Optional parameters
      modules: [Navigation, Autoplay],
      direction: 'horizontal',
      loop: true,
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 80,
      // Responsive breakpoints
      autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
    
     // If we need pagination
      pagination: {
        el: '.swiper-main-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-main-next',
        prevEl: '.swiper-button-main-prev',
      },
    
     
    });
  
  },
  
  

}
